import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Location } from "@angular/common";
import { filter } from "rxjs/operators";
import * as firebase from "firebase/app";
import "firebase/analytics";

declare const ga: any;

@Injectable()
export class AnalyticsService {
  private enabled: boolean;
  private analytics: any;

  constructor(private location: Location, private router: Router) {
    this.enabled = true;
    this.analytics = firebase.default.analytics();
  }

  trackPageViews() {
    if (this.enabled) {
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.analytics.logEvent("send", {
            hitType: "pageview",
            page: this.location.path(),
          });
        });
    }
  }

  trackEvent(eventName: string) {
    if (this.enabled) {
      this.analytics.logEvent("send", "event", eventName);
    }
  }
}
